import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import parse from "html-react-parser"

import { connectionShape } from "app/lib/shared_prop_types"
import proPlusBadge from "images/plan-badges/pro_plus.svg?raw"
import proBadge from "images/plan-badges/pro.svg?raw"

import "./small_applet_card.module.scss"

export default class Meta extends Component {
  render() {
    const { applet } = this.props
    const needsProBadge = applet.pro_features || applet.intermediate_pro_features

    return (
      <div className={classnames("meta", { badged: needsProBadge })}>
        {needsProBadge && (
          <span title={`Applet has pro features`} className="card-badge">
            {parse(applet.pro_features ? proPlusBadge : proBadge)}
          </span>
        )}
      </div>
    )
  }
}

Meta.propTypes = {
  applet: connectionShape.isRequired,
  mainService: PropTypes.object,
}
